<template>
    <div>
        <!-- Main Header-->
        <header class="main-header">

            <!--Header Top-->
            <div class="header-top">
                <div class="auto-container">
                    <div class="clearfix">
                        <!--Top Left-->
                        <div class="top-left">
                            <ul class="top-links clearfix">
                                <li style="cursor: pointer;" v-on:click="routeMeTo('/contact')"><span class="icon theme_color flaticon-e-mail-envelope"></span>contact@bcom.eu</li>
                            </ul>
                        </div>
                        <div class="top-right">
                            <ul class="top-links clearfix">
                                <li style="cursor: pointer;" v-for="entry in languages" :key="entry.title" v-on:click="changeLocale(entry.language)"><flag :iso="entry.flag" v-bind:squared=false /> {{entry.title}}</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

            <!--Header-Upper-->
            <div class="header-upper">
                <div class="auto-container">
                    <div class="clearfix">

                        <div class="logo-outer">
                            <div class="logo" id="logo"><a href="/" class="nav-link"><img src="images/logo-bcom.png" alt="" title=""></a></div>
                        </div>

                        <div class="upper-right clearfix">

                            <div class="nav-outer clearfix">
                                <!-- Main Menu -->
                                <nav class="main-menu">
                                    <div class="navbar-header">
                                        <!-- Toggle Button -->
                                        <button type="button" class="navbar-toggle" data-toggle="collapse" data-target=".navbar-collapse">
                                        <span class="icon-bar"></span>
                                        <span class="icon-bar"></span>
                                        <span class="icon-bar"></span>
                                        </button>
                                    </div>

                                    <div class="navbar-collapse collapse clearfix">
                                        <ul class="navigation clearfix">
                                            <li v-bind:class="currentPa === 'home' ? 'current' : ''"><a href="/" class="nav-link">{{ $t('common.menu.home') }}</a>
                                            </li>
                                            <li v-bind:class="currentPa.startsWith('services') ? 'dropdown current' : 'dropdown'"><router-link to="/services-activities" class="nav-link">{{ $t('common.menu.services') }}</router-link>
                                                <ul>
                                                    <li><router-link to="/services-activities" class="nav-link">{{ $t('common.menu.activities') }}</router-link></li>
                                                    <li><router-link to="/services-academy" class="nav-link">{{ $t('common.menu.support-to-academic-groups') }}</router-link></li>
                                                    <li><router-link to="/services-biotech-pharma" class="nav-link">{{ $t('common.menu.support-to-biotech-and-pharma') }}</router-link></li>
                                                </ul>
                                            </li>
                                            <li v-bind:class="currentPa === 'about' ? 'current' : ''"><router-link to="/about" class="nav-link">{{ $t('common.menu.about-company') }}</router-link></li>



                                            <li v-bind:class="currentPa === 'contact' ? 'current' : ''"><router-link to="/contact" class="nav-link">{{ $t('common.menu.contact-us') }}</router-link></li>
                                        </ul>
                                    </div>
                                </nav>
                                <!-- Main Menu End-->



                            </div>

                        </div>

                    </div>
                </div>
            </div>
            <!--End Header Upper-->

            <!--Sticky Header-->
            <div class="sticky-header">
                <div class="auto-container clearfix">
                    <!--Logo-->
                    <div class="logo pull-left">
                        <a href="/" class="img-responsive" title="B-COM"><img src="images/logo-small-bcom.png" alt="B-COM" title="B-COM"></a>
                    </div>

                    <!--Right Col-->
                    <div class="right-col pull-right">
                        <!-- Main Menu -->
                        <nav class="main-menu">
                            <div class="navbar-header">
                                <!-- Toggle Button -->
                                <button type="button" class="navbar-toggle" data-toggle="collapse" data-target=".navbar-collapse">
                                <span class="icon-bar"></span>
                                <span class="icon-bar"></span>
                                <span class="icon-bar"></span>
                                </button>
                            </div>

                            <div class="navbar-collapse collapse clearfix">
                                <ul class="navigation clearfix">
                                    <li v-bind:class="currentPa === 'home' ? 'current' : ''"><a href="/" class="nav-link">{{ $t('common.menu.home') }}</a>
                                    </li>
                                    <li v-bind:class="currentPa.startsWith('services') ? 'dropdown current' : 'dropdown'"><router-link to="/services-activities" class="nav-link">{{ $t('common.menu.services') }}</router-link>
                                        <ul>
                                            <li><router-link to="/services-activities" class="nav-link">{{ $t('common.menu.activities') }}</router-link></li>
                                            <li><router-link to="/services-academy" class="nav-link">{{ $t('common.menu.support-to-academic-groups') }}</router-link></li>
                                            <li><router-link to="/services-biotech-pharma" class="nav-link">{{ $t('common.menu.support-to-biotech-and-pharma') }}</router-link></li>
                                        </ul>
                                    </li>
                                    <li v-bind:class="currentPa === 'about' ? 'current' : ''"><router-link to="/about" class="nav-link">{{ $t('common.menu.about-company') }}</router-link></li>
                                    <li v-bind:class="currentPa === 'contact' ? 'current' : ''"><router-link to="/contact" class="nav-link">{{ $t('common.menu.contact-us') }}</router-link></li>
                                </ul>
                            </div>
                        </nav><!-- Main Menu End-->
                    </div>

                </div>
            </div>
            <!--End Sticky Header-->

        </header>
        <!--End Main Header -->

        <!--Page Title-->
        <section v-if="currentPa !== 'home'" class="page-title" style="background-image:url(images/background/6.jpg);">
            <div class="auto-container">
                <h1>{{pageTitle}}</h1>
            </div>
        </section>
        <!--End Page Title-->

        <!--Page Info-->
        <section v-if="currentPa !== 'home'" class="page-info">
            <div class="auto-container">
                <div class="inner-container clearfix">
        
                    <div class="pull-left">
                        <ul class="bread-crumb clearfix">
                            <li><a href="/">{{ $t('common.menu.home') }}</a></li>
                            <li>{{pageTitle}}</li>
                        </ul>
                    </div>
                    <div class="pull-right">
                    </div>
        
                </div>
            </div>
        </section>
        <!--End Page Info-->
    </div>
</template>

<script>
    export default {
      name: 'section-header',
      data() {
        return {
          content: '',
          languages: [
              { flag: 'gb', language: 'en', title: 'English' },
              { flag: 'fr', language: 'fr', title: 'Français' }
          ]
        };
      },
      methods: {
        routeMeTo: function(link) {
           if (link !== '/' + this.$router.history.current.name) {
              this.$router.push(link);
           }
        },
        changeLocale: function(locale) {
            this.$root.$i18n.locale = locale;
            this.$cookies.set("language", locale);
        }
      },
      computed: {
       currentPa() {
            return this.$router.history.current.name.replaceAll('-', ' ');
       },
       pageTitle() {
            if("services" === this.$router.history.current.name) {
                document.title = 'B-COM | ' + this.$root.$i18n.t('common.page-title.activities');
                return this.$root.$i18n.t('common.menu.activities');

            } else if("services-activities" === this.$router.history.current.name) {
                document.title = 'B-COM | ' + this.$root.$i18n.t('common.page-title.activities');
                return this.$root.$i18n.t('common.menu.activities');

            } else if("services-academy" === this.$router.history.current.name) {
                document.title = 'B-COM | ' + this.$root.$i18n.t('common.page-title.support-to-academic-groups');
                return this.$root.$i18n.t('common.menu.support-to-academic-groups');

            } else if("services-biotech-pharma" === this.$router.history.current.name) {
                document.title = 'B-COM | ' + this.$root.$i18n.t('common.page-title.support-to-biotech-and-pharma');
                return this.$root.$i18n.t('common.menu.support-to-biotech-and-pharma');

            } else if("contact" === this.$router.history.current.name) {
                document.title = 'B-COM | ' + this.$root.$i18n.t('common.page-title.contact-us');
                return this.$root.$i18n.t('common.menu.contact-us');

            } else if("about" === this.$router.history.current.name) {
                document.title = 'B-COM | ' + this.$root.$i18n.t('common.page-title.about-company');
                return this.$root.$i18n.t('common.menu.about-company-title');

            } else {
                document.title = 'B-COM';
                return this.$router.history.current.name.replaceAll('-', ' ');
            }
       },
      },
      mounted() {
        var language = this.$cookies.get("language");
        if (language) {
            this.$root.$i18n.locale = language;
        }

      }
    };
</script>

